import {ChangeEvent, useCallback, useEffect} from 'react';

import {useSelector} from 'react-redux';

import {getSelectedShippingMethod} from '../../store/selectors/shippingMethods/shippingMethods';

import {useShippingProtectionActions} from './useShippingProtectionActions';
import {useShippingProtectionEligible} from './useShippingProtectionEligible';
import {useShippingProtectionEnabled} from './useShippingProtectionEnabled';

/**
 * Shipping protection logic hook
 */
export const useShippingProtection = () => {
    const isEligible = useShippingProtectionEligible();
    const selectedShipping = useSelector(getSelectedShippingMethod);
    const {isEnabled: isProtectionEnabled} = useShippingProtectionEnabled();
    const price = selectedShipping?.shippingProtectionPrice || 0;

    const {addProtection, isLoading, removeProtection} = useShippingProtectionActions();

    const onCheckboxChange = useCallback(
        async ({target: {checked}}: ChangeEvent<HTMLInputElement>) => {
            if (!isEligible) return;

            await (checked ? addProtection() : removeProtection());
        },
        [addProtection, removeProtection, isEligible],
    );

    useEffect(() => {
        // if protection is enabled and then it changes to ineligible
        if (isProtectionEnabled && !isEligible) {
            removeProtection();
        }
    }, [isProtectionEnabled, isEligible, removeProtection]);

    return {
        isEligible,
        isLoading,
        onCheckboxChange,
        price,
    };
};
